import React, { useEffect, useState } from 'react';
import './App.css';
import Controller from './Controller/Controller';
import 'semantic-ui-css/semantic.min.css'

const ALLOWED_PARENT_ORIGIN = 'https://crm.axcap.ae';
const DEV_HOSTS = ['localhost', '127.0.0.1'];

function App() {
  const isDevHost = DEV_HOSTS.includes(window.location.hostname);
  const [authorized, setAuthorized] = useState(isDevHost)
  const [accessChecked, setAccessChecked] = useState(isDevHost || window.self === window.top)
  const [bitrixUserId, setBitrixUserId] = useState(null)

  useEffect(() => {
    if (isDevHost) {
      setAuthorized(true);
      setAccessChecked(true);
      return;
    }

    if (window.self === window.top) {
      setAuthorized(false);
      setAccessChecked(true);
      return;
    }

    const accessTimeout = window.setTimeout(() => {
      setAccessChecked(true);
    }, 1500);

    const handleParentMessage = (event) => {
      if (event.origin !== ALLOWED_PARENT_ORIGIN) {
        return;
      }

      if (event.data?.type !== 'PARENT_URL') {
        return;
      }

      if (event.data.url?.startsWith(ALLOWED_PARENT_ORIGIN)) {
        setAuthorized(true);
        setBitrixUserId(event.data.userId || null);
      }

      setAccessChecked(true);
      window.clearTimeout(accessTimeout);
    }

    window.addEventListener('message', handleParentMessage);

    return () => {
      window.clearTimeout(accessTimeout);
      window.removeEventListener('message', handleParentMessage);
    }
  }, [isDevHost]);

  if (!accessChecked) {
    return <div className="access-state">Checking access...</div>
  }

  if(!authorized){
    return <div className="access-state">Access Denied</div>
  }

  return (
    <div className="App">
      <Controller bitrixUserId={bitrixUserId}/>
    </div>
  );
}

export default App;
